<template>
  <div>
    <CModuleHeader 
      :horizontalMargin="2"
      @mouseenter="emitContextualHelpChanged('layer')"
      @mouseleave="emitContextualHelpChanged(null)"
      class="text-over"
    >{{ $t('layoutTitle') }}</CModuleHeader>

    <CModuleContent
      :height="23"
      :horizontalMargin="2"
    >
      <div class="row mt-2 mb-2">
        <div class="col-2"></div>
        <div class="col-8">
          <TrinnovInput
            @mouseenter="emitContextualHelpChanged('algo')"
            @mouseleave="emitContextualHelpChanged(null)"
            buttonType="select"
            :modelValue="algoSelected"
            :selectOptions="renderAlgoList"
            size="auto"
            :event="true"
            @TrinnovInputChanged="emitAlgoChanged"
          ></TrinnovInput>
        </div>

        <div class="col-2">
          <TrinnovInput
            v-if="algoSelected !== 'custom'"
            buttonType="buttonIcon"
            id="edit"
            :modelValue="false"
            :svgPath="require('@/lib/tui/assets/common/edition/edit.svg')"
            size="auto"
            :event="true"
            @TrinnovInputChanged="emitAlgoChanged({value: 'custom'})"
          ></TrinnovInput>
        </div>
      </div>

      <!-- <div class="row mt-1">
          <div class="col-3">
            <TrinnovInput
              buttonType="checkbox"
              :id="-2"
              :modelValue="layerSelected === -2 ? true : false"
              :event="true"
              @TrinnovInputChanged="emitLayerChanged"
            ></TrinnovInput>
          </div>

          <div class="col-2">
            <div class="legend" :style="'background:' + renderMLPColor"></div>
          </div>

          <div 
            class="col-4 text-over text-left"             
            @mouseenter="emitContextualHelpChanged('mlp')"
            @mouseleave="emitContextualHelpChanged(null)"
          >{{ $t('mlp') }}</div>
        </div> -->
    
      <div>

        <div class="row mt-1">
          <div class="col-3">
            <TrinnovInput
              v-if="algoSelected === 'custom'"
              buttonType="checkbox"
              :id="0"
              :modelValue="layerSelected === 0 ? true : false"
              :event="true"
              @TrinnovInputChanged="emitLayerChanged"
            ></TrinnovInput>
          </div>

          <div class="col-2" style="margin-top: -0.4vh">
            <TrinnovInput
              buttonType="buttonIcon"
              :withBackground="false"
              id="edit"
              :isActivable="false"
              :modelValue="false"
              :svgPath="require('@/components/measures/settings/point_ear.svg')"

            ></TrinnovInput>
          </div>

          <div 
            class="col-4 text-over text-left"
            @mouseenter="emitContextualHelpChanged('layer_0')"
            @mouseleave="emitContextualHelpChanged(null)"
          >
            {{ $t('measureHelpTitle_layer_0') }}
          </div>
        </div>

        <div class="row mt-1">
          <div class="col-3">
            <TrinnovInput
              v-if="algoSelected === 'custom'"
              buttonType="checkbox"
              :id="1"
              :modelValue="layerSelected === 1 ? true : false"
              :event="true"
              @TrinnovInputChanged="emitLayerChanged"
            ></TrinnovInput>
          </div>

          <div class="col-2" style="margin-top: -0.4vh">
            <TrinnovInput
              buttonType="buttonIcon"
              :withBackground="false"
              id="edit"
              :isActivable="false"
              :modelValue="false"
              :svgPath="require('@/components/measures/settings/point_top.svg')"

            ></TrinnovInput>
          </div>

          <div 
            class="col-4 text-over text-left"
            @mouseenter="emitContextualHelpChanged('layer_1')"
            @mouseleave="emitContextualHelpChanged(null)"
          >
            {{ $t('measureHelpTitle_layer_1') }}
          </div>
        </div>

      </div>
    </CModuleContent>
  </div>
</template>

<script>
import CModuleHeader from "@/lib/tui/template/container/module/CModuleHeader.vue";
import CModuleContent from "@/lib/tui/template/container/module/CModuleContent.vue";
import TrinnovInput from "@/lib/tui/components/buttons/TrinnovInput.vue";
export default {
  name: "CLayers",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  components: {
    TrinnovInput,
    CModuleHeader,
    CModuleContent
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  props: {
    algoSelected: {
      type: String,
      required: true,
    },
    algoList: Array,
    layerColors: Array,
    layerSelected: Number,
    mlpRow: Number,
    mlpCol: Number,
    mlpID: Number
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {
    emitAlgoChanged: function(event) {
      this.$emit("AlgoChanged", event.value);
    },
    ///////////////////////////////////////////////////////////////
    emitLayerChanged: function(event) {
      if (!event.value) return;  
      this.$emit("LayerChanged", event);
    },
    ///////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit("ContextualHelpChanged", event);
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  computed: {
    renderMLPColor: function() {
      if (!this.layerColors || this.layerColors.length === 0) return;

      return this.layerColors.find(s => s.id === -2).color;
    },
    ///////////////////////////////////////////////////////////////
    renderLayersAvailables: function() {
      if (!this.layerColors || this.layerColors.length === 0) return;
      let layers = [];

      for (let i = 0; i < this.layerColors.length; i++) {
        if (this.layerColors[i].id >= 0)
          layers.push(this.layerColors[i]);
      }

      return layers;
    },
    ///////////////////////////////////////////////////////////////
    renderAlgoList: function() {
      let algoList = [...this.algoList];

      if (this.algoSelected === 'custom')
        algoList.push({ id: "custom", label: this.$t('custom') });

      return algoList;


    }
  }
}
</script>

<style lang="scss" scoped>
  .legend {
    width: 3vw;
    height: 1vh;
    margin-top: 1.5vh;
  }
</style>